import { Injectable } from '@angular/core';
import { RenderTemplateRequest, TemplatesApiService } from '@vendasta/templates';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ReviewResponseTemplateParameters {
  reviewerFirstName?: string;
  reviewerFullName?: string;
  starRating?: string;
  businessName?: string;
  businessAddress?: string;
  businessPhoneNumber?: string;
  businessWebsite?: string;
  businessEmail?: string;
  username?: string;
}

@Injectable()
export class ReviewCardResponseTemplatesService {
  constructor(protected readonly templatesApiService: TemplatesApiService) {}

  public renderResponseTemplate(
    externalTemplateId: string,
    parameters: ReviewResponseTemplateParameters,
    applicationId: string,
  ): Observable<string> {
    const renderRequest = new RenderTemplateRequest({
      applicationId: applicationId || 'reputation',
      templateId: externalTemplateId,
      parameters: parameters,
    });
    return this.templatesApiService.renderTemplate(renderRequest).pipe(map((response) => response.renderedTemplate));
  }
}
